const state = {
  year: 0,
  catalog: '',
  handoutFilters: {},
  cmsTypes: [],
  textBook: '',
  defaultbook: [],
  bkId: '',
  formats: [],
  kps: [],
  singleormulti: '1',
  bookorkps: 1,
  factors: {}
}
export default state
